import { render, staticRenderFns } from "./selection.vue?vue&type=template&id=47f700e5&scoped=true"
import script from "./selection.vue?vue&type=script&lang=js"
export * from "./selection.vue?vue&type=script&lang=js"
import style0 from "./selection.vue?vue&type=style&index=0&id=47f700e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f700e5",
  null
  
)

export default component.exports